<div class="adx-lib-widget-view-wrapper">
    <div #obcNavigationInstrumentContainer class="adx-navigations-instrument-wrapper">
        <div class="adx-obc-azimuth-thruster-labeled-wrapper">
            <obc-azimuth-thruster-labeled #azimuthThrusterLabeledContainer
                    [angle]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.angle"
                    [angleSetpoint]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.angleSetpoint"
                    [thrust]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.thrust"
                    [thrustSetpoint]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.thrustSetpoint"
                    [label]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.label"
                    [angleAdvices]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.angleAdvices"
                    [thrustAdvices]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.thrustAdvices"
                    [commandStatus]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.commandStatus"
                    [topPropeller]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.topPropeller"
                    [bottomPropeller]="obcNavigationsInstrumentsInstance.azimuthThrusterLabeled.bottomPropeller"
                    >
            </obc-azimuth-thruster-labeled>
        </div>
    </div>
</div>
